import type * as core from '../../core'

export interface IdcCategorization {
  category: IdcCategorization.Category
  subcategory?: IdcCategorization.Subcategory
}

export namespace IdcCategorization {
  /**
   * Formats an IDC categorization as its category code, followed by its
   * subcategory code in parentheses when present.
   *
   * @example `OM (UW)` or `INST`
   */
  export function format({ category, subcategory }: IdcCategorization): string {
    return subcategory
      ? `${category.code} (${subcategory.code})`
      : category.code
  }

  export type Category = core.common.Identified<core.dms.data.Record.Id> &
    core.common.Named &
    core.common.Coded

  export type Subcategory = Category

  export interface Ids {
    categoryId: core.dms.data.Record.Id
    subcategoryId?: core.dms.data.Record.Id
  }
}
